export default {
  Tips_Common: {
    non_system_interface: '非本系统的接口',
    bad_request: '请求错误',
    relogin: '请重新登录',
    request_404: '请求地址404',
    request_timeout: '请求超时',
    system_unavailable: '系統暫不可用，請稍後重試或聯繫工作人員',
    login_invalid: '登陆信息已失效，请重新登录',
    account_other_login: '账号在其他地方登录',
    unknown_error: '未知错误',
    // err_network: '网络异常，请检查网络连接',
    request_error: '请求失败',
    Changes_Clinic_Settings: '正在修改診所診治設置，是否保存？',
    Cntrols_Successfully: '操作成功',
    Input_Promotion_Name: '請輸入轉介碼名称',
    Input_Promotion_Code: '請輸入轉介碼',
    select_yishi: '請選擇醫師',
    select_shouquan_yishi: '請選擇授權醫師',
    shouquan_same_yishi: '授權醫師不能和醫師相同',
    shouquan_example_tip: '* 示例：李四（醫師）—楊一（授權醫師）',
    reset_successfully: '重置成功',
    edit_successfully: '修改成功',
    add_successfully: '新增成功',
    complete_certificate: '請完善證書列表',
    has_confirm_shutdown: '數據發生了修改，確認關閉？',
    enter_account: '請輸入賬號',
    must_account_less: '賬號長度不能少於6',
    must_account_than: '賬號長度不能大於20',
    must_account_fomat: '格式為單一或任意組合的字母數字和字符_-@.並且長度為6~20',
    format_error: '輸入格式錯誤',
    enter_id: '請輸入證件號碼',
    must_id_less: '證件號碼長度需大於等於0',
    perfect_source: '請先完善號源',
    file_format_incorrect: '文件格式不正確, 請上傳jpeg、png或pdf格式文件',
    enter_name: '請輸入姓名',
    enter_phone: '請輸入手機號',
    select_birth: '請選擇出生日期',
    select_doctor_category: '請選擇醫師類型',
    select_sex: '請選擇性別',
    select_scheduling: '請選擇是否排班',
    enter_describe: '請輸入描述',
    select_cert_type: '請選擇證書類型',
    enter_certificate_numb: '請輸入證書編號',
    enter_certificate_title: '請輸入證書名稱',
    select_issue_date: '請選擇發證時間',
    upload_attachment: '請上傳附件',
    search_menu: '搜索菜單',
    full_screen: '全屏',
    full_screen_out: '退出全屏',
    content_recovery: '內容區復原',
    content_enlargement: '內容區放大',
    content_full_screen: '內容區全屏',
    deleting_role: '正在刪除角色',
    confirm_deletion: '確認刪除',
    del_successfully: '刪除成功',
    input_bag_time: '請輸入包/次',
    input_g_bag: '請輸入克/包',
    bag_time_need: '包/次不可為0',
    g_bag_need: '克/包不可為0',
    method_need: '請至少選擇一種支付方式',
    postage_need: '請輸入郵費',
    cannot_null: '電子秤設定值不可為空！',
    end_equal_start: '電子秤設定結束值必須等於下一階段的開始值！',
    config_save_no: '正在修改診所配置，是否保存？',
    config_save_no_logout: '正在修改診所配置，保存後將退出登錄，是否確定？',
    save_successfully: '保存成功',
    err_network: '網絡錯誤，請稍後重試',
    loading: '加載中',
    discount_example: '80% = 8折',
    denomination_need: '請輸入面額',
    discount_need: '請輸入折扣',
    enter_coupon_name: '請輸入優惠券名稱',
    enter_setmeal_name: '請輸入套票名稱',
    select_is_coupon: '請選擇是否優惠券',
    select_coupon_type: '請選擇優惠券類型',
    select_is_enable: '請選擇是否啟用',
    enter_amount: '請輸入金額',
    select_scope_use: '請選擇使用範圍',
    denomination_less_amount: '面額必須小於滿減目標金額',
    min_warning_less_max: '最小預警量必須小於最大預警量',
    sliding_expiry_hint: '自發放日起 {duration}{unit}後過期',
    taopiao_sliding_expiry_hint: '自購買日起 {duration}{unit}後過期',
    enter_expiration_duration: '請輸入過期時長',
    expiration_duration_range: '過期時長需在1-{max}{unit}之間（最長10年）',
    select_expiration_time: '請選擇過期時間',
    expiration_time_before_sale_end: '固定日期過期不能早於售賣結束日期',
    expiration_time_before_today: '固定日期過期不能早於今天',
    end_time_before_start_time: '結束時間不能早於開始時間',
    select_expiration_type: '請選擇過期類型',
    deleting_project: '正在刪除項目',
    attachment_load: '附件上傳中，請稍後',
    information_backfill: '當前證件號碼存在用戶信息，是否回填',
    cannot_activated: '此藥品平台已停用，需啟用請聯繫平台管理者',
    select_address: '請選擇地址信息',
    tips_address: '詳細地址長度需要在2-120個漢字或字符, 不能包含表情符號',
    use_default: '是否確認設置為默認地址',
    enter_pingyin: '請輸入中文或拼音',
    enter_code: '請輸入編碼',
    enter_price: '請輸入售價',
    enter_min_whole: '請輸入最少單位量',
    enter_max_whole: '請輸入最大單位量',
    complete_order: '是否完結當前訂單？',
    order_completed: '訂單已完成',
    cancel_successfully: '取消成功',
    no_record: '暫無簽收記錄',
    no_data: '暫無數據',
    enter_opinion: '請輸入審批意見',
    audit_completed: '審核完成',
    enter_description: '請輸入項目描述',
    cannot_empty: '訂單不可為空',
    submit_successfully: '提交成功',
    clear_order_list: '確認清空訂單列表',
    temporary_successfully: '暫存成功',
    bring_quantity: '一鍵帶入下單數量',
    least_one_drug: '至少需要簽收一樣藥品！',
    confirm_receipt: '確認簽收訂單',
    continue_sign: '簽收數量為0，是否繼續簽收',
    sign_successfully: '簽收成功',
    expired_continue_sign: '藥品已過了有效期，是否繼續簽收',
    sign_remaining_all: '是否簽收全部剩下下單數量',
    invalid_barcode: '無效的碼',
    not_onpurchase: '藥品不在採購列表中',
    signings_not_exceed: '簽收數量不可多於下單數量',
    whether_backfill: '當前證件號存在用戶信息，是否回填',
    enter_prepaid_name: '請輸入級別名稱',
    select_level: '請選擇級別',
    enter_discount: '請輸入級別優惠',
    enter_discount_zero: '級別優惠不能為0',
    enter_threshold: '請輸入起步金額',
    enter_threshold_zero: '起步金額不能為0',
    deleting_card: '正在刪除儲值級別',
    level_exists: '級別已存在',
    starting_exists: '起步金額已存在',
    confirm_report: '確定上報',
    cntrols_successfully: '操作成功',
    no_standard: '沒有配置標準',
    sign_first: '請先簽名',
    report_first: '上報成功',
    be_un_inequality: '兩次輸入的新密碼不一致',
    KeKong_BuXiuGai: '可空不修改，不填則維持原樣',
    password_length_max: '密碼長度不能超過16位',
    confirm_delete_group: '刪除當前組會將連帶關聯的收費規則及收費項目一起刪除，是否確認刪除',
    confirm_delete_rule: '刪除當前規則會將連帶關聯的收費項目一起刪除，是否確認刪除',
    set_default: '是否確認設置為默認收費類別',
    use_price: '使用藥物的售價收費',
    use_cost: '使用藥物的成本收費',
    use_ticket: '使用套票的售價收費',
    use_fee: '使用醫師的診金收費',
    edit_print: '正在修改打印配置，是否保存',
    pay_modify: '預設開啟後收費信息不可編輯',
    enter: '請輸入',
    sku_exists: '藥品已經存在',
    complete_dosage: '請完善藥品用量',
    acupoint_exists: '穴位已經存在',
    drug_detail: '詳情(使用飲片用量)',
    confirm_syncing: '是否確定同步藥品信息至當前產品',
    empty_no: '不可為空',
    prefix_repeat: '字頭不可重複',
    un_down_data: '當前沒有可下載的數據',
    complete_rule: '請完善規則列表！',
    input_name_code: '支持產品名稱、編碼搜索',
    input_name_code_phone: '支持客戶編號、證件號碼、姓名、電話搜索',
    input_code_name_phone: '支持證件號碼、姓名、電話搜索',
    input_name_en: '請輸入中文姓名或者英文姓名',
    birthday_out: '出生日期不可超過今天',
    electronic_empty: '電子秤設定值不可為空',
    start_next: '電子秤設定結束值必須等於下一階段的開始值',
    input_type: '請輸入類別',
    source_get_tips1: '* 將生成新號源，請確定是否覆蓋舊號源。',
    source_get_tips2: '覆蓋（從第二天開始生成）',
    source_get_tips3: '不覆蓋（從最後號源的第二天開始生成）',
    no_chinese_id: '證件號碼不可輸入中文',
    no_chinese: '不可輸入中文',
    complete_certificate_list: '請完善證書列表！',
    openTime_closeTime_no: '營業時間設定值不可為空！',
    openTime_closeTime_before: '營業時間的結束時間必須在開始時間之後！',
    openTime_pre_closeTime_after: '營業時間的開始時間必須在上一階段的結束時間之後！',
    days_cannot_empty: '天數不可為空！',
    frequency_cannot_empty: '每天/次不可為空！',
    confirm_delete: '是否確認刪除？',
    QueRen_BaoCun: '確認保存？',
    QueRen_YanQi: '是否確認延期？',
    QueRen_She_YouXiaoQi: '是否確認設定有效期？',
    QueRen_YanQi_Zhi: '是否確認延期至 {date}？',
    QueRen_She_YouXiaoQi_Zhi: '是否確認設定有效期至 {date}？',
    ChuFang_ChaoGuo: '處方數量超過兩條，是否繼續套用？',
    TuPian_Jpg_Png: '圖片必須是jpeg或者png格式！',
    TuPian_Size_2MB: '圖片大小必須小於2MB！',
    TuPian_Size_5MB: '圖片大小必須小於5MB！',
    FuJian_Size_10MB: '附件大小必須小於10MB！',
    HaoYuan_save_no: '正在修改診症號源，是否保存？',
    ChaoJi_GuanLiYuan_Ming: '不可以使用超級管理員作為角色名！',
    apply_last_scheduling: '檢測到上次排班數據，是否套用？',
    interval_save_no: '修改每節時間將會清空當前診所的所有排班以及原有排班規則，是否繼續？',
    source_day_max: '生成號源天數不能超過720天',
    interval_changed: '每節時間發生改變，將清空排班規則及已生成的號源！',
    no_set_ratio: '沒有設置濃度',
    use_precious: '使用藥物的名貴藥材附加收費！',
    effective_upon_next_login: '修改成功，下次登錄後生效',
    delete_successfully: '刪除成功',
    start_time_cannot_be_after_end_time: '開始時間不能晚於結束時間',
    cannot_delete_use: '已使用禁止刪除',
    cannot_delete: '不可刪除',
    cannot_delete_reservation: '存在預約禁止刪除',
    select_clinic: '請選擇診所',
    select_change_time: '請選擇變動時間',
    hebing_tuijian_tip: '勾選快捷推薦（電話/姓名/證件號碼）或輸入關鍵字搜索，再自行勾選待合併患者',
    // ===== 簡體遷移：硬編碼提示語收編（2026-09-23） =====
    QueRen_KaiYong: '確認啟用？',
    QueRen_TingYong: '確認停用？',
    QueRen_KaiYong_PaiBan: '確認啟用排班？',
    QueRen_TingYong_PaiBan: '確認停用排班？',
    QueRen_ShanChu_JiaoSe: '正在刪除角色：{name}，確認刪除？',
    QueRen_ShanChu_CaiDan: '正在刪除菜單：{name}，確認刪除？',
    QueRen_ShanChu_XiangMu: '正在刪除項目：{name}，確認刪除？',
    QueRen_ShanChu_TaoPiao: '正在刪除套票：{name}，確認刪除？',
    QueRen_ShanChu_YouHuiQuan: '正在刪除優惠券：{name}，確認刪除？',
    QueRen_ShanChu_HuoDong: '正在刪除活動：{name}，確認刪除？',
    QueRen_ShanChu_HuanZhe: '正在刪除患者檔案：{name}，確認刪除？',
    QueRen_ShanChu_TiaoZheng: '正在刪除調整記錄，確認刪除？',
    QueRen_ShanChu_CaiGouDan: '正在刪除採購單，確認刪除？',
    QueRen_ShanChu_PanDian: '正在刪除盤點記錄，確認刪除？',
    QueRen_ShanChu_PiCi: '正在刪除批次號，確認刪除？',
    QueRen_ShanChu_ZhuanJieMa: '正在刪除轉介碼：{name}，確認刪除？',
    ZhengZai_ShanChu_ShouQuan: '正在刪除：【{staff}】對【{toStaff}】的授權，確認刪除？',
    ZhengZai_ShanChu_ShouQuan_HuanZhe: '正在刪除：患者【{patient}】對【{toStaff}】的授權，確認刪除？',
    QueRen_QuXiao: '確認取消[{orderNo}]？',
    QueRen_QuXiao_CaiGouDan: '確認取消採購單[{orderNo}]？',
    QingXuanZe_YingYeDiDian: '請選擇具體營業地點！',
    QingWanShan_YaoPinGuiGe: '請完善藥品規格信息！',
    QingWanShan_ChengFenYao: '請完善成分藥列表！',
    QingWanShan_MingGuiYao: '請完善名貴藥材附加收費信息！',
    QingWanShan_GuiZeLieBiao: '請完善{types}規則列表！',
    QingBuQuan_ShiYongCiShu: '請補全使用次數或優惠金額限制，且不可為0！',
    TaoPiao_XiangMu_WeiKong: '套票項目不能為空！',
    QingXuanZe_YaoPin: '請選擇藥品！',
    QingXuanZe_ShangPin: '請選擇商品！',
    CunZai_WuXiao_YaoPin: '存在無效藥品，不可保存！',
    QingXuanZe_FaFang_KeHu: '請選擇想要發放的客戶！',
    QingShuRu_FaFangShuLiang: '請輸入給每個客戶發放的優惠券數量：',
    ZhengZai_FaFang_YouHuiQuan: '正在發放優惠券：{name}',
    QueRen_FaFang_QuanBu: '正在發放優惠券：{name}，每個客戶發放{quantity}張，確認發放給全部客戶？',
    QueRen_FaFang: '正在發放優惠券：{name}，每個客戶發放{quantity}張，確認發放？',
    YaoPin_YiGuoQi: '藥品已過期，是否繼續加入？',
    Deng_YaoPin: ' 等藥品',
    ChengBenJia_WeiKong: '成本價不可為0或空',
    XiaDanShuLiang_WeiKong: '下單數量不可為0或空',
    QingXuanZe_ShiJianFanWei: '請選擇時間範圍',
    KaiShi_BuNeng_DaYu_JieShu: '開始時間不能大於結束時間',
    BuNeng_ChaXun_ChaoYiNian: '不能查詢超過一年的時間段',
    QingXuanZe_ShiJian: '請選擇時間',
    ChuCun_ShiBai: '儲存失敗',
    ShengCheng_HaoYuan_Tip: '是否立即為當前醫師生成該診所的預約號源？',
    ShengCheng_HaoYuan_Last: '確定根據當前醫師最後一次保存的排班規則生成預約號源？',
    QingKong_HaoYuan_Tip: '當前操作將清空該醫師在此診所之前配置的所有號源，是否繼續？',
    MeiJie_QieHuan_Tip: '每節時間切換為{minutes}分鐘，將自動調整號源時間，請確認是否繼續？',
    QingShuRu_HaoYuanTianShu: '請輸入生成號源天數！',
    ZuBie_WeiKong: '組別設定值不可為空',
    ZuBie_JieShu_BuPiPei: '組別設定結束值必須等於下一階段的開始值',
    ZhongXinDengLu_ShengXiao: '本次修改將在重新登錄後生效，確認修改？',
    TingYong_WuFa_HuiFu: '停用後將無法再次啟用，確認？',
    MiMa_BuYiZhi: '兩次輸入的新密碼不一致！',
    XinMiMa_Tong_JiuMiMa: '新密碼不能與舊密碼一致！',
    YingYeShiJian_WeiKong: '營業時間的星期不可為空！',
    YingYeShiJian_ChenFu: '營業時間的星期不可重複！',
    ChongJian_SuoYin_Tip: '將清空並重建患者索引信息，重建成功前可能影響患者信息，是否確定？',
    ChangDu_7_Zhi_11: '長度在 7 到 11 個字符',
    Tian: '天',
    Yue: '個月',
    Nian: '年',
    Yuan: '元',
    ChaoGuo: '超過',
    Mei: '每',
    JiangShouFei: '收費',
    An_ZhongLiang_JiFei: '按重量計費',
    An_ChengBen_JiFei: '按成本計費',
    An_WeiShu_JiFei: '按味數計費',
    BingZhengZhi: '病-證-治',
    GongKai_SiYou_Tip: '公開 - 診所中的任何人都可以查看',
    SiMi_SiYou_Tip: '私密 - 只有您自己可以查看',
    QingXianShuRu_BingMing: '請先輸入病名',
    QingXianShuRu_ZhengXing: '請先輸入證型',
    RenShen: '妊娠',
    JinZhi_Label: '禁止',
    JingGao_Label: '警告',
    ZhiBiao: '指標',
    LiShi_PaiBan: '歷史排班',
    ZanWu_LiShi_PaiBan: '暫無歷史排班資料',
    QuanBu_Label: '全部',
    GuiShu_Label: '歸屬',
    Zhou_Label: '週',
    FenChai_Dian: '分拆點',
    XuanZe_GuanLiYuan: '選擇管理員',
    ShuRu_XingMing_DianHua: '輸入姓名或電話',
    YouHuiQuan_FaFang_Title: '優惠券發放',
    KuCun_TiaoZheng_Title: '庫存調整',
    JianYi_CaiGouLiang: '建議採購量',
    QieHuan_Label: '切換',
    GuanBi_Label: '關閉',
    Gong_N_Xiang: '共 {total} 項',
    SouSuo_CaiDan: '搜索菜單',
    SouSuo_JieGuo: '搜索結果',
    WuFa_JinRu_CaiDan: '無法通過搜索進入該菜單，請為對應的路由設置唯一的 Name',
    CaiDan_BiXu_CanShu: '該菜單有必填的動態參數，無法通過搜索進入',
    LiuLanQi_WuFa_GongZuo: '您的瀏覽器無法工作',
    YunXu_XinChuangKou: '請允許瀏覽器打開新窗口！',
    QuanPing_Label: '全屏',
    TuiChu_QuanPing: '退出全屏',
    BuJu_PeiZhi: '佈局配置',
    GongNeng_PeiZhi: '功能配置',
    ChongZhi_Label: '重 置',
    XianShi_Logo: '顯示 Logo',
    GuDing_Header: '固定 Header',
    XianShi_YeJiao: '顯示頁腳 Footer',
    ZuoCe_MoShi: '左側模式',
    DingBu_MoShi: '頂部模式',
    HunHe_MoShi: '混合模式',
    DiTu_JiaZai_ShiBai: '地圖加載失敗，請檢查高德Key配置',
    GaoDe_Key_WuXiao: '高德Key無效或未授權地理編碼服務，請檢查Key配置並開啟安全密鑰',
    DiLiBianMa_ShiBai: '地理編碼失敗：{info}',
    QingShuRu_DiZhi: '請輸入地址',
    DiTu_WeiChuShiHua: '地圖服務未初始化，請稍後重試',
    WeiZhaoDao_DiZhi: '未找到地址：{keyword}',
    QingXuanZe_DiDian: '請先選擇一個地點',
    LuYouShouWei_CuoWu: '路由守衛過程發生錯誤',
    ZhiYeXuKeZheng_ZhengBen: '醫療機構執業許可證正本',
    ZhiYeXuKeZheng_FuBen: '執業許可證副本',
    ZhiYeXuKeZheng_NianJian: '執業許可證副本最新年檢時間頁',
    MinZhengJu_BeiAn: '民政局備案',
    YingYeZhiZhao: '營業執照',
    ZuZhi_JiGouDaiMa: '組織機構代碼證',
    ShuiWu_DengJiZheng: '稅務登記證',
    FangShe_ZhenLiaoXuKe: '放射診療許可證',
    FangShe_AnQuanXuKe: '放射安全許可證',
    XianJin_E_Song: '現金額（贈送）',
    Yuan_E_Song: '原金額（贈送）',
    LaiYuan_Label: '來源',
    ZhenSuo_MaoHao: '診所：',
    FaFangShuLiang_CuoWu: '發放數量必須是1-5的非零正整數',
    FaFang_HaoShi_Tip: '發放全部時間比較久，請稍後...',
    FaFang_HouTai_Tip: '後台持續發放中，請於晚些時候刷新頁面查看',
    TiaoMa_ErWeiMa_WeiKong: '條碼、二維碼不能同時為空！',
    QueRen_GengXin_YaoPin: '確認更新當前所有藥品信息？',
    JiaoSe_XinXi_ShiBai: '角色信息獲取失敗',
    QuanXian_BaoCun_ChengGong: '角色權限保存成功',
    QuanXian_BaoCun_ShiBai: '角色權限保存失敗',
    ChongJian_SuoYin_Label: '重建索引',
    HeBing_QueRen_Tip:
      '將把以下 {count} 位患者的病歷及就診信息合併到主患者【{name}】：{list}。合併後這些患者檔案將被刪除，且不可恢復，確定合併？',
    Zan_Wu_SouSuo_JieGuo: '暫無搜索結果',
    QingShuRu_HuoDong_JiaGe: '請填寫每項商品的活動價格（可為 0，不可留空）',
    QingShuRu_HuoDong_ZheKou: '請填寫每項商品的活動折扣（需大於 0，不可留空）',
    HuoDong_ZheKou_BuKe_Wei_Ling: '活動折扣不可為 0',
  },
}
